import { NestedTableNestedModeState } from '../../state';
import { action, makeObservable } from 'mobx';
import { NestedDragAndDropState } from './NestedDragAndDropState';

export interface NestedTableDragAndDropStateParams<C extends string> {
  readonly nestedState: NestedTableNestedModeState<C>;
  readonly modalsContainerRef: {
    current: HTMLElement | null | undefined;
  };
}

export class NestedTableDragAndDropState<C extends string> {
  readonly tableState;
  readonly dragAndDrop;

  constructor(params: NestedTableDragAndDropStateParams<C>) {
    const { nestedState, modalsContainerRef } = params;

    this.tableState = nestedState.tableState;

    this.dragAndDrop = new NestedDragAndDropState({
      state: nestedState.toolbar,
      collection: nestedState,
      container: nestedState.tableState.toolbar.container,
      a11yContainer: modalsContainerRef?.current,
    });

    makeObservable(this, {
      init: action,
    });
  }

  getStickyColumnsCount({
    stickyColumns,
    horizontalScroll,
  }: {
    stickyColumns: number;
    showSelection?: boolean;
    horizontalScroll?: boolean;
  }) {
    const { dragAndDrop } = this;
    return horizontalScroll && !dragAndDrop.dnd.isDisabled
      ? stickyColumns + 1
      : stickyColumns;
  }

  init({ a11yContainer }: { a11yContainer?: HTMLElement | null | undefined }) {
    const { dragAndDrop, tableState } = this;

    tableState.tableDragAndDropStateInitialized = true;

    return dragAndDrop.init({
      a11yContainer,
    });
  }
}
